export function button(item, type, lastbutton) {
  const button = `<a href="${item.route != null ? item.route.path : item.url}" ${type != "" ? `data-type="actionbutton"` : ``} class="group flex flex-nowrap max-w-fit justify-center items-center bg-blue text-white text-base font-bold py-[10px] px-6 gap-4 rounded-[107px] transition:bg-blue duration-150 ease-in-out hover:bg-blue-black" ${!lastbutton ? `target="_blank"` : ``} class="btn btn-blue"><span>${item.title}</span><svg class="h-6 w-6 fill-white dot-arrow-animation">
  <use xlink:href="/spritemap.svg#sprite-dotarrow"></use>
  </svg></a>  
  `;
  return button;
}
